import React from "react";

import App from "./App";
import { Provider } from "react-redux";
import store from "./store/store";
import "./index.css";

import { createRoot } from "react-dom/client";

createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <App />
  </Provider>
);
